import { combineEpics } from "redux-observable";
import templateSelectionEpics from "./views/TemplateSelection/epics/TemplateSelectionEpic.js";
import managementGroupProviderEpics from "./views/TemplateSelection/epics/ManagementGroupProviderEpic.js";
const rootEpic = combineEpics(templateSelectionEpics, managementGroupProviderEpics);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
